


















































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Page} from "@/model/page";
import moment from "moment";
import Icon from "@/components/BrandIcon.vue";
import BrandIcon from "@/components/BrandIcon.vue";
import {FraudCase} from "@/model/fraud-case";
import {fraudCaseService} from "@/services/fraud-case";
import FraudCaseDetails from "@/components/FraudCaseDetails.vue";
import CreateFraudCaseDialog from "@/components/CreateFraudCaseDialog.vue";
import ExpandFraudCase from "@/components/ExpandFraudCase.vue";

@Component({
  components: {ExpandFraudCase, CreateFraudCaseDialog, FraudCaseDetails, BrandIcon, Icon}
})
export default class FraudCaseTable extends Vue {

  @Prop()
  caseIds?: string[]

  @Prop()
  cases?: FraudCase[]

  pageSize = 50;
  page = 1
  loading = true
  serverItemsLength = 0;

  create = false;

  fraudCasePage: Page<FraudCase> = new Page<FraudCase>()
  fraudCases: FraudCase[] = []

  expand = false
  expanded: FraudCase = new FraudCase();

  async mounted() {
    if(this.caseIds) {
      this.fraudCases = await Promise.all(this.caseIds.map(id => fraudCaseService.getFraudCaseById(id)))
    } else if (this.cases && this.cases.length > 0) {
      this.fraudCases = this.cases;
    } else {
      this.fraudCasePage = await fraudCaseService.getFraudCases(this.page-1,this.pageSize);
      this.serverItemsLength = this.fraudCasePage.totalElements;
    }
    this.loading = false;
  }

  expandFraudCase(item: FraudCase){
    console.log(item)
    this.expanded = item
    this.expand = true
  }

  @Watch('cases')
  async onCasesChanged() {
    if(this.cases) {
      this.fraudCases = this.cases;
      this.serverItemsLength = this.cases.length;
    }
  }

  @Watch('caseIds')
  async onIdsChanged() {
    console.log('Fraud case ids changes inside table')
    if(this.caseIds) {
      this.loading = true;
      this.fraudCases = await Promise.all(this.caseIds.map(id => fraudCaseService.getFraudCaseById(id)))
      this.loading = false;
    }
  }

  @Watch('page')
  @Watch('pageSize')
  async onPageChange() {
    if(!this.caseIds) {
      this.loading = true;
      this.fraudCasePage = await fraudCaseService.getFraudCases(this.page-1,this.pageSize);
      this.serverItemsLength = this.fraudCasePage.totalElements;
      this.loading = false;
    }
  }

  toPrettyDate(num: number) {
    return moment(num).format('D/MM/YYYY, h:mm a');
  }

  get items() {
    return this.cases && this.cases.length > 0? this.fraudCases : this.caseIds ? this.fraudCases : this.fraudCasePage.content
  }

  get _headers() {
    return [
      {
        text: 'Id',
        value: 'id',
      },
      {
        text: 'Source Transaction',
        align: 'start',
        value: 'blacklistTransactionId',
      },
      {
        text: 'Created (DD/MM/YYYY)',
        value: 'blacklistedDate'
      },
      {
        text: 'Updated (DD/MM/YYYY)',
        value: 'lastUpdateDate'
      },
      {
        text: 'Source Chargeback',
        value: 'hasChargebacks'
      },
      {
        text: 'Source Stole card',
        value: 'hasStolenCards'
      },
      {
        text: 'Expand',
        value: 'expand'
      },
      {
        text: 'Comment',
        value: 'blacklistComment'
      }
    ];
  }
}
